import { useKFlags } from '@/hooks/use-k-flags';
import { KText } from '@/ui-library/components';
import { Link } from '@chakra-ui/react';

export const Title = ({ groupBy = null, filters = {}, ...props }) => {
  const { ats_enabled } = useKFlags();

  if (!groupBy) return null;
  // Determine the display text based on the value of groupBy
  const rawDisplay =
    groupBy === -1 ? 'Unknown' : groupBy?.name || groupBy?.title || groupBy;
  const displayText =
    filters?.group_by === 'job_name' && (groupBy === -1 || rawDisplay === 'Unknown')
      ? 'No associated job'
      : rawDisplay;

  if (filters?.group_by === 'flow') {
    return (
      <Link href={`/flows/${groupBy?.id}`} target="_blank">
        <KText
          size={ats_enabled ? 'xs-medium' : 'sm-medium'}
          width="130px"
          textAlign={ats_enabled ? 'start' : undefined}
          textDecoration="underline"
          {...props}
        >
          {displayText}
        </KText>
      </Link>
    );
  }

  if (filters?.group_by === 'job') {
    return (
      <Link href={`/jobs/${groupBy?.id}`} target="_blank">
        <KText
          size={ats_enabled ? 'xs-medium' : 'sm-medium'}
          width="130px"
          textAlign={ats_enabled ? 'start' : undefined}
          textDecoration="underline"
          {...props}
        >
          {displayText}
        </KText>
      </Link>
    );
  }

  return (
    <KText
      size="sm-medium"
      width="130px"
      textAlign={ats_enabled ? 'start' : undefined}
      {...props}
    >
      {displayText}
    </KText>
  );
};
